export default __webpack_public_path__ + "static/404-12e1c2be73fdfcb81d42c5490e618526.png";